<template>
    <profile-card title="Promotions">
            <div class="acc-setting profile-series-h">
                <div v-if="loading" class="cp-field">
                    <div class="form-row">
                        <div class="form-group col">
                            <label>
                                <loading
                                        :active="loading"
                                        :can-cancel="false"
                                        loader="dots"
                                        color="#2292ef"
                                        :is-full-page="false"
                                ></loading>
                            </label>
                        </div>
                    </div>
                </div>
                <!--save-stngs end-->
                <div v-else class="container">
                    <table class="table table-bordered" style="margin-bottom:10px;">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Product</th>
                            <th scope="col">Discount</th>
                            <th scope="col">Start Date</th>
                            <th scope="col">End Date</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(single, i) in promotions" :key="i">
                            <td scope="row" style="width:80px;">{{ i + 1 }}</td>
                            <td style="width:100px;">{{single.product_title}}</td>
                            <td>{{single.discount}}</td>
                            <td>{{single.start_date}}</td>
                            <td>{{single.end_date}}</td>
                            <td>{{single.status}}</td>
                            <td>
                                <div class="btn-group">
                                <add-promotion class="d-inline" button-title="Edit" :user-product="single.user_product" @update="onPromotionUpdate"></add-promotion>
                                <delete-promotion class="d-inline ml-1" :pro-id="single.id" @update="onPromotionUpdate"></delete-promotion>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
    </profile-card>
</template>

<script>
    import CoolLightBox from "vue-cool-lightbox";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import EventBus from '../../../../front/eventBus';

    export default {
        components: {
            CoolLightBox,
            Loading,
        },
        props: {},
        data() {
            return {
                loading: false,
                promotions: [],
            };
        },
        created() {
            this.fetch();
        },
        mounted(){
            EventBus.$on('PROMOTION_CHANGED', () => {
                this.onPromotionUpdate();
            })
        },
        methods: {
            fetch(){
                this.loading = true;
                axios.get("/api/v1/trader-promotion?&api_token=" + window.api_token).then(res => {
                    this.promotions = res.data.data;
                    this.loading = false;
                })
            },
            onPromotionUpdate(){
                this.fetch();
                this.$emit('update');
            },
        }
    };
</script>
<style scoped></style>
